import HttpService from '@/modules/shared/services/httpService';
import Vue from 'vue';
import router from '@/router';
import VueAppInsights from 'vue-application-insights';
import LoaderService from '@/modules/shared/services/loaderService';
import AxiosService from '@/services/AxiosService';

export default async function initializeApplication(): Promise<number> {
  const httpService = new HttpService();
  httpService.loaderService = new LoaderService();
  const axios = new AxiosService();

  // const result = await httpService.httpInstance.get('config.json');
  const config = await axios.axiosInstance.get('api/cnf');
  const usr = await axios.axiosInstance.get('api/UserInfo');
  Vue.prototype.$appConfig = config.data;
  Vue.prototype.$user = usr.data;

  // window.$config = result.data;

  Vue.use(VueAppInsights, {
    id: 'ssdsdsd',
    router,
    trackInitialPageView: true,
    onAfterScriptLoaded: (data: any) => {
      data.addTelemetryInitializer(
        (envelope: any) => {
          envelope.data.applicationName = 'WakalaVerification';
          if (typeof (envelope.baseData) === 'string') {
            const name = envelope.baseData;
            envelope.baseData = {};
            envelope.baseData.name = name;
          }
        },
      );
    },
  });

  return Promise.resolve(1);
}
